import React, { useEffect, useState, useCallback } from "react"; // Added useCallback
import { CircularProgress, CircularProgressLabel, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import useMedia from "../../../hooks/useMedia";
import { useSettings } from "../../../hooks/useSettings";
// useSettings is not strictly needed in Progress anymore if lunchType is passed from Clock

// good luck trying to change this. I used ai because it was so bad. This was from the previous version. Its too ugly to change without a full refactor AGAIN.

// From Nic, I mean it only works with clock, used by clock, sets up circular progress bar, 
// I think it handles some cases and not all, and they share functionality on some stuff. Good luck

dayjs.extend(require("dayjs/plugin/customParseFormat"));
dayjs.extend(require("dayjs/plugin/duration"));

// Pass userLunchType as a prop
const Progress = ({ genText, period, nextPeriod, lunchStatus, currentTime, userLunchType }) => {
  const mobile = useMedia(["(min-width: 750px)", "(max-width: 750px)"], [false, true]);

  // No longer need local state for lunchText, use userLunchType prop directly
  // const [lunchText, setLunchText] = useState("");
  // const {settings, updateSettings} = useSettings(); // No longer needed here

  // useEffect(() => {
  //   const dayType = settings.dayType;
  //   setLunchText(dayType === "Royal" ? settings.royalDay : settings.grayDay);
  // }, [settings]);


  const { settings } = useSettings();

  // Returns { range, diffFromStart } for the currently active countdown segment
  // (regular period, lunch, bag drop off/pickup, etc.) so both the percentage
  // and the remaining-time check use identical logic.
  const genSegment = useCallback(() => {
    if (!period) return null;

    let range, diffFromStart;
    let targetPeriod = period; // Default to the current period

    // If there are lunch periods and a specific userLunchType is provided
    if (period.lunchPeriods && userLunchType && period.lunchPeriods[userLunchType]) {
      const userLunchPeriod = period.lunchPeriods[userLunchType];

      switch (lunchStatus) { // Use lunchStatus directly as a string
        // Bag drop off only exists on B lunch (added for 4 to 3 lunch switch)
        case "BAG_DROP_OFF":
          if (userLunchPeriod.bagDropOff) {
            // Progress within the bag drop off window itself
            range = userLunchPeriod.bagDropOff.endTimeUnix - userLunchPeriod.bagDropOff.startTimeUnix;
            diffFromStart = currentTime - userLunchPeriod.bagDropOff.startTimeUnix;
            targetPeriod = userLunchPeriod.bagDropOff;
            break;
          }
          // fall through to BEFORE behavior if bagDropOff is somehow missing
        case "DURING":
          // Progress within the user's specific lunch period
          range = userLunchPeriod.endTimeUnix - userLunchPeriod.startTimeUnix;
          diffFromStart = currentTime - userLunchPeriod.startTimeUnix;
          targetPeriod = userLunchPeriod; // Set target to lunch period for percentage calculation
          break;
        case "BEFORE":
          // Progress from the start of the current period until the start of lunch
          range = userLunchPeriod.startTimeUnix - period.startTimeUnix;
          diffFromStart = currentTime - period.startTimeUnix;
          break;
        // Bag pickup only exists on D lunch (added for 4 to 3 lunch switch)
        case "BAG_PICKUP":
          if (userLunchPeriod.bagPickup) {
            // Progress within the bag pickup window itself
            range = userLunchPeriod.bagPickup.endTimeUnix - userLunchPeriod.bagPickup.startTimeUnix;
            diffFromStart = currentTime - userLunchPeriod.bagPickup.startTimeUnix;
            targetPeriod = userLunchPeriod.bagPickup;
            break;
          }
          // fall through to AFTER behavior if bagPickup is somehow missing
        case "AFTER":
          // Progress from the end of lunch (or bag pickup) until the end of the current period
          range = period.endTimeUnix - userLunchPeriod.endTimeUnix;
          diffFromStart = currentTime - userLunchPeriod.endTimeUnix;
          // Ensure diffFromStart doesn't go negative if currentTime is exactly at lunch end
          if (diffFromStart < 0) diffFromStart = 0;
          break;
        default:
          // No specific lunch status, treat as a regular period
          range = period.endTimeUnix - period.startTimeUnix;
          diffFromStart = currentTime - period.startTimeUnix;
      }
    } else {
      // No lunch periods or userLunchType, calculate for the entire period
      range = period.endTimeUnix - period.startTimeUnix;
      diffFromStart = currentTime - period.startTimeUnix;
    }

    return { range, diffFromStart };
  }, [period, currentTime, lunchStatus, userLunchType]); // Add dependencies

  const genPercent = useCallback(() => {
    const segment = genSegment();
    if (!segment) return 0;
    const { range, diffFromStart } = segment;

    // Handle division by zero for very short periods or if range is 0 for some reason
    if (range <= 0) return 100; // Or 0, depending on desired behavior for zero-length periods

    const percentage = (diffFromStart / range) * 100;
    return Math.min(100, Math.max(0, percentage)); // Clamp between 0 and 100
  }, [genSegment]);

  const isCountdownWarning = useCallback(() => {
    const warningMinutes = settings.countdownWarningMinutes;
    if (!warningMinutes) return false;
    const segment = genSegment();
    if (!segment) return false;
    const { range, diffFromStart } = segment;
    if (range <= 0) return false;
    const remainingMs = range - diffFromStart;
    return remainingMs > 0 && remainingMs <= warningMinutes * 60 * 1000;
  }, [genSegment, settings.countdownWarningMinutes]);

  const renderTimerText = () => {
    if (!period) return "Loading...";

    return (
      <>
        <Text marginBottom={0} fontSize={mobile ? "3rem" : "80px"}>
          {genText()}
        </Text>
        <Text
          fontSize={mobile ? "1.3rem" : "1.5rem"}
          marginTop="0"
          wordSpacing="3px"
        >
          {period.lunchPeriods && userLunchType // Use userLunchType for display
            ? {
              // Bag drop off only exists on B lunch (added for 4 to 3 lunch switch)
              BAG_DROP_OFF: `Until Bag Drop Off Ends`,
              DURING: `Until ${userLunchType} Lunch Ends`,
              BEFORE: `Until ${userLunchType} Lunch`,
              // Bag pickup only exists on D lunch (added for 4 to 3 lunch switch)
              BAG_PICKUP: `Until Bag Pickup Ends`,
              AFTER: nextPeriod ? `Until ${period.periodName} Ends` : `Until School Ends`,
            }[lunchStatus] // Use lunchStatus directly
            : `Until ${period.periodName} Ends`}
        </Text>
      </>
    );
  };
  const warning = isCountdownWarning();

  return (
    <div>
      <CircularProgress
        trackColor="var(--background-secondary)"
        color={warning ? "#d10f41" : "var(--color-primary)"}
        thickness={3.5}
        size={mobile ? window.innerWidth * 0.85 : 580}
        value={genPercent()}
        capIsRound={true}
      >
        <CircularProgressLabel fontSize={50}>
          {renderTimerText()}
        </CircularProgressLabel>
      </CircularProgress>
    </div>
  );
};

export default Progress;